/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { Formik } from 'formik';
import { FC, useRef, useState } from 'react';
import * as yup from 'yup';
import { useFormContext } from '../../../../../contexts/FormContext';
import {
  DiscountPromotionInput,
  FormType,
  GiveAwayPromotionInput,
  PersonaBlogInput,
  SeasonalHolidayInput,
  YoutubeChannelDescriptionInput,
  YoutubeVideoScriptInput,
} from '../../../../../types/FormTypes';
import { ListenToFormikValues } from '../../../../shared/formik/ListenToFormikValues';
import { GenerateResponseButtons } from '../GenerateResponseButtons';
import formStyles from '../formStyles.module.css';
import { AdvancedInputs } from '../formInputs/AdvancedInputs';
import { usePersonaContext } from '../../../../../contexts/PersonaContext';
import axios from 'axios';
import { ToggleInput } from '../../../../shared/inputs/ToggleInput';
import { useRouter } from 'next/router';
import React from 'react';
import Image from 'next/image';
import styled from '@emotion/styled';
import { useEffect } from 'react';
import styles from './YoutubeStyles.module.css';
import { BoxedAutoResizeTextarea } from '../../../../shared/inputs/BoxedAutoResizeTextarea';
import { BasicPopup2 } from '../../../../shared/popups/BasicPopup';
import { BrandPersonaSoloPopup } from '../../../personasPage/BrandPersonaPopupSolo';
import { ProductPersonaSoloPopup } from '../../../personasPage/productPersonaPopup';
import { AudiencePersonaSoloPopup } from '../../../personasPage/AudiencePersonaPopup';
import { BasicButton } from '../../../../shared/buttons/BasicButton';
import { SmallerSimpleBadge } from '../../../../shared/badge/SmallerSimpleBadge';
import { EditBrandPersonaPopup } from '../../../personasPage/EditBrandPersonaPopup';
import { EditProductPersonaPopup } from '../../../personasPage/EditProductPersonaPopup';
import { EditAudiencePersonaPopup } from '../../../personasPage/EditAudiencePersonaPopup';
import { BasicInput } from '../../../../shared/inputs/BasicInput';
import { BasicButtonSelectionInput } from '../../../../shared/inputs/BasicButtonSelectionInput';
import { useAuthContext } from '../../../../../contexts/AuthContext';
import { BrandPersona, ProductPersona, AudiencePersona } from '../../../../../types/Persona.type';

const DropDownContainer = styled('div')`
  width: 100%;
  cursor: pointer;
  font-family: "Poppins", sans-serif;
  position: relative;
  display: flex;
  z-index: 0;
  flex-direction: column;
  padding: 0em 0.3em 0em 0em;
`;

const DropDownContainer2 = styled('div')`
  width: 100%;
  cursor: pointer;
  position: relative;
  display: flex;
  z-index: 3;
  flex-direction: column;
  padding: 0em 0.3em 0em 0em;
`;

const DropDownContainer3 = styled('div')`
  width: 100%;
  cursor: pointer;
  position: relative;
  display: flex;
  z-index: 2;
  flex-direction: column;
  padding: 0em 0.3em 0em 0em;
`;

const DropDownIcon = styled('div')`
  position: sticky;
  left: 100%;
  display: flex;
  z-index: 4;
  flex-direction: column;
`;

const DropDownIcon2 = styled('div')`
  position: sticky;
  left: 100%;
  display: flex;
  z-index: 3;
  flex-direction: column;
`;

const DropDownIcon3 = styled('div')`
  position: sticky;
  left: 100%;
  display: flex;
  z-index: 2;
  flex-direction: column;
`;

const DropDownHeader = styled('div')`
  width: 100%;
  cursor: pointer;
  margin-bottom: 0.4em;
  padding: 0.5em 0.5em 0.5em 0.5em;
  font-weight: 400;
  font-size: 1rem;
  color: black;
  font-family: "Poppins", sans-serif;
  background: white;
  border: 1px solid black;
  border-radius: 4px;
  display: flex;
`;

const DropDownListContainer = styled('div')`
  width: 100%;
  cursor: pointer;
  font-weight: 500;
  font-size: 1.3rem;
  font-family: "Poppins", sans-serif;
  color: #3faffa;
  background: white;
  border: 1.83px solid black;
  border-radius: 2px;
  width: 100%;
  z-index: 0;
  max-height: 41vh;
`;

const DropDownList = styled('ul')`
  width: 100%;
  cursor: pointer;
  padding: 0;
  margin: 0;
  z-index: 0;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 2px;
  color: black;
  font-size: 0.9rem;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
  max-height: 40vh;
  overflow: scroll;
  overflow-x: hidden;
  &:first-of-type {
    padding-top: 0em;
  }
`;

const ListItem = styled('li')`
  width: 100%;
  cursor: pointer;
  list-style: none;
  padding-bottom: 0.6em;
  padding-top: 0.6em;
  padding-left: 1em;
  border-bottom: 1px solid black;
  font-family: "Poppins", sans-serif;
  display: flex;
  z-index: 500;

  justify-content: space-between;
  align-items: center;
  &: last-of-type {
    border-bottom: 0px;
  }

  &:hover {
    color: #4690ff;
    background-color: #dadada;
  }
`;

const ListItem2 = styled('li')`
  width: 100%;
  cursor: pointer;
  list-style: none;
  padding-bottom: 0.8em;
  padding-top: 0.8em;
  padding-left: 1em;
  border-bottom: 1px solid black;
  color: gray;
  display: flex;
  font-family: "Poppins", sans-serif;
  align-items: center;

  &:hover {
    color: #4690ff;
    background-color: #dadada;
  }
`;

const Innertext = styled('div')`
  padding-top: 0.4em;
  padding-left: 0.5em;
`;

const Innertext2 = styled('div')`
  padding-top: 0.5em;
  padding-left: 0.5em;
  padding-bottom: 0.5em;
`;

interface ChildComponentProps {
  onButtonClick: (
    v1: string,
    id: string,
    v3: string,
    v4: string[],
    v5: string,
    v6: string,
    v7: string,
    v8: string,
    v9: string[],
    v10: { replaceThis: string; withThis: string }[],
    v11: string[],
    p1: string,
    p2: string,
    p3: string,
    p4: { value: string; label: string },
    a1: string,
    a2: { value: string; label: string },
    a3: string[],
    a4: string[],
    a5: string[],
    a6: string[],
    a7: string,
    a8: string,
    a9: string,
    a10: string,
    a11: string,
    a12: string,
    neededMenu: string
  ) => void;
}

const EGInputsSchema = yup.object<
  Partial<Record<keyof YoutubeVideoScriptInput, yup.AnySchema>>
>({
  videoTopic: yup.string().required('Please add the topic of the video'),
  videoPurpose: yup.string().required('Please select a purpose for the video'),
  // duration: yup.string().required('Please add the duration'),
  //   companyWebsite: yup.string().notRequired(),
  // intent: yup
  //   .string()
  //   .required('Please enter the intent of your blog post')
  //   .min(5, 'Intent is too vague! Consider adding more details'),
  //   topics: yup.array().of(yup.string()).min(0, ''),
  // tone: yup
  //   .array()
  //   .of(yup.string())
  //   .min(1, 'Please select at least 1 tone for your blog post'),
  // toneDegree: yup.object(),
  //   length: yup
  //     .mixed<InputLength>()
  //     .oneOf(Object.values(InputLength))
  //     .required('Please select a length for your blog post'),
});

export const YoutubeVideoScriptForm: FC<ChildComponentProps> = ({
  onButtonClick,
}) => {
  const {
    youtubeVideoScriptInput,
    setYoutubeVideoScriptInput,
    setCanKeepGoing,
    loading,
    submitContentForm,
  } = useFormContext();
  const router = useRouter();
  const {
    brandPersonas,
    audiencePersonas,
    productPersonas,
    deleteBrand,
    deleteProduct,
    deleteAudience,
    currentAudPersona,
    currentBrandPersona,
    currentProductPersona,
    saveCurrentPersonas,
  } = usePersonaContext();
  const { userData, logRecentPersonaData } = useAuthContext();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    currentBrandPersona?.brand ?? 'Please Select a Brand'
  );
  const [selectedBrand, setSelectedBrand] = useState('');
  const [picture, setPicture] = useState(currentBrandPersona?.profilePic ?? '');
  const [picture2, setPicture2] = useState(currentAudPersona?.profilePic ?? '');
  const [selectedAudOption, setSelectedAudOption] = useState(
    currentAudPersona?.audience ?? 'Please Select an Audience'
  );
  const [selectedAudience, setAudienceList] = useState('');
  const [selectedProOption, setSelectedProOption] = useState(
    'Please Select a Product'
  );
  const [selectedProduct, setProductList] = useState('');
  const menuRef = useRef<HTMLDivElement>(null);
  const menuRef2 = useRef<HTMLDivElement>(null);
  const menuRef3 = useRef<HTMLDivElement>(null);
  const [brandError, setBrandError] = useState(false);
  const [audError, setAudError] = useState(false);
  const [proError, setProError] = useState(false);
  useEffect(() => {
    const handler = (e: { target: any }) => {
      if (!menuRef3.current?.contains(e.target)) {
        setIsOpen3(false);
      }
      if (!menuRef2.current?.contains(e.target)) {
        setIsOpen2(false);
      }
      if (!menuRef.current?.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
    };
  });

  const toggling = () => setIsOpen(!isOpen);
  const toggling2 = () => {
    if (B1 === '') {
      setShouldJiggle(true);
      setTimeout(() => {
        setShouldJiggle(false);
      }, 500); // 500ms is the duration of your jiggle animation
    } else {
      setIsOpen2(!isOpen2);
    }
  };
  const toggling3 = () => {
    if (B1 === '') {
      setShouldJiggle(true);
      setTimeout(() => {
        setShouldJiggle(false);
      }, 500); // 500ms is the duration of your jiggle animation
    } else {
      setIsOpen3(!isOpen3);
    }
  };
  const [showBrandPopup, setShowBrandPopup] = useState(false);
  const [showAudiencePopup, setShowAudiencePopup] = useState(false);
  const [showProductPopup, setShowProductPopup] = useState(false);
  const [showEditPopup, setEditPopup] = useState(false);
  const [showDeletePopup, setDeletePopup] = useState(false);
  const [showProEditPopup, setProEditPopup] = useState(false);
  const [showProDeletePopup, setProDeletePopup] = useState(false);
  const [showAudEditPopup, setAudEditPopup] = useState(false);
  const [showAudDeletePopup, setAudDeletePopup] = useState(false);

  const [B1, setB1] = useState(currentBrandPersona?.brand ?? ''); //brand
  const [B2, setB2] = useState(currentBrandPersona?.description ?? ''); //brandDescription
  const [B3, setB3] = useState(currentBrandPersona?.website ?? ''); //website
  const [B4, setB4] = useState(currentBrandPersona?.tone ?? ['']); // tone
  const [B5, setB5] = useState(currentBrandPersona?.industry ?? ''); // industry
  const [B6, setB6] = useState(currentBrandPersona?.brandPositioning ?? ''); // brandPositioning
  const [B7, setB7] = useState(currentBrandPersona?.brandNoNoWords ?? ['']); // brandAvoid
  const [B8, setB8] = useState(
    currentBrandPersona?.brandReplacementWords ?? [
      { replaceThis: '', withThis: '' },
    ]
  ); // brandReplacementing
  const [B9, setB9] = useState(
    currentBrandPersona?.brandUseSparinglyWords ?? ['']
  ); // brandSparingly
  const [A0, setA0] = useState(currentAudPersona?.audience ?? ''); //audience
  const [A1, setA1] = useState(currentAudPersona?.painpoints ?? ''); //painpoint
  const [A2, setA2] = useState(currentAudPersona?.location ?? ['']); //location
  const [A3, setA3] = useState(currentAudPersona?.occupation ?? ['']); //occupation
  const [A4, setA4] = useState(currentAudPersona?.age ?? ['']); //age
  const [A5, setA5] = useState(currentAudPersona?.goals ?? ''); //goals
  const [A6, setA6] = useState(currentAudPersona?.barriers ?? ''); //barriers
  const [A7, setA7] = useState(currentAudPersona?.triggers ?? ''); //triggers
  const [A8, setA8] = useState(currentAudPersona?.profilePic ?? ''); //ProfilePic
  const [P1, setP1] = useState(''); //product
  const [P2, setP2] = useState(''); // productdescription

  const [v1, setv1] = useState('');
  const [id, setv2] = useState('');
  const [v3, setv3] = useState('');
  const [v4, setv4] = useState(['']);
  const [v5, setv5] = useState('');
  const [v6, setv6] = useState('');
  const [v7, setv7] = useState('');
  const [v8, setv8] = useState('');
  const [v9, setv9] = useState(['']);
  const [v10, setv10] = useState([{ replaceThis: '', withThis: '' }]);
  const [v11, setv11] = useState(['']);
  const [p1, setp1] = useState('');
  const [p2, setp2] = useState('');
  const [p3, setp3] = useState('');
  const [p4, setp4] = useState({ value: '', label: '' });
  const [a1, seta1] = useState('');
  const [a2, seta2] = useState({ value: '', label: '' });
  const [a3, seta3] = useState(['']);
  const [a4, seta4] = useState(['']);
  const [a5, seta5] = useState(['']);
  const [a6, seta6] = useState(['']);
  const [a7, seta7] = useState('');
  const [a8, seta8] = useState('');
  const [a9, seta9] = useState('');
  const [a10, seta10] = useState('');
  const [a11, seta11] = useState('');
  const [a12, seta12] = useState('');

  const [buttonClicked, setButtonClicked] = useState(false);
  const [neededMenu, setNeededMenu] = useState('');

  useEffect(() => {
    if (buttonClicked) {
      sendData();
      setButtonClicked(false);
    }
  }, [buttonClicked]);

  const onOptionClicked =
    (
      value: React.SetStateAction<string>,
      value2: React.SetStateAction<string>,
      value3: React.SetStateAction<string>,
      value4: React.SetStateAction<string[]>,
      value5: React.SetStateAction<string>,
      value6: React.SetStateAction<string>,
      value7: React.SetStateAction<string>,
      value8: React.SetStateAction<string[]>,
      value9: React.SetStateAction<{ replaceThis: string; withThis: string }[]>,
      value10: React.SetStateAction<string[]>,
      entireBrand: React.SetStateAction<BrandPersona>,
    ) =>
      () => {
        setSelectedOption(value);
        setB1(value);
        setB2(value2);
        setB3(value3);
        setB4(value4);
        setB5(value5);
        setB6(value7);
        setB7(value8);
        setB8(value9);
        setB9(value10);
        saveCurrentPersonas(
                      {} as ProductPersona,
                      {} as AudiencePersona,
                      entireBrand as BrandPersona
                    );
        setPicture(value6);
        setBrandError(false);
        setIsOpen(false);
      };

  const onAudOptionClicked =
    (
      value: React.SetStateAction<string>,
      value2: React.SetStateAction<string>,
      value3: React.SetStateAction<string[]>,
      value4: React.SetStateAction<string[]>,
      value5: React.SetStateAction<string[]>,
      value6: React.SetStateAction<string>,
      value7: React.SetStateAction<string>,
      value8: React.SetStateAction<string>,
      v9: React.SetStateAction<string>,
      entireAud: React.SetStateAction<AudiencePersona>,
    ) =>
      () => {
        setSelectedAudOption(value);
        setA0(value);
        setA1(value2);
        setA2(value3);
        setA3(value4);
        setA4(value5);
        setA5(value6);
        setA6(value7);
        setA7(value8);
        setA8(v9);
        saveCurrentPersonas(
                  {} as ProductPersona,
                  entireAud as AudiencePersona,
                );
        setPicture2(v9);
        setAudError(false);
        setIsOpen2(false);
      };

  const onProOptionClicked =
    (
      value: React.SetStateAction<string>,
      value2: React.SetStateAction<string>
    ) =>
      () => {
        setSelectedProOption(value);
        setP1(value);
        setP2(value2);
        setIsOpen3(false);
      };

  const BrandCreateClick = () => {
    setNeededMenu('BrandCreate');
    setButtonClicked(true);
  };

  const BrandEditClick =
    (
      v1: React.SetStateAction<string>,
      v2: React.SetStateAction<string>,
      v3: React.SetStateAction<string>,
      v4: React.SetStateAction<string[]>,
      v5: React.SetStateAction<string>,
      v6: React.SetStateAction<string>,
      v7: React.SetStateAction<string>,
      value8: React.SetStateAction<string>,
      v9: React.SetStateAction<string[]>,
      v10: React.SetStateAction<{ replaceThis: string; withThis: string }[]>,
      v11: React.SetStateAction<string[]>
    ) =>
      () => {
        setv1(v1);
        setv2(v2);
        setv3(v3);
        setv4(v4);
        setv5(v5);
        setv6(v6);
        setv7(v7);
        setv8(value8);
        setv9(v9);
        setv10(v10);
        setv11(v11);
        setNeededMenu('BrandEdit');
        setButtonClicked(true);
      };

  const BrandDeleteClick =
    (
      v1: React.SetStateAction<string>,
      v2: React.SetStateAction<string>,
      v3: React.SetStateAction<string>,
      v4: React.SetStateAction<string[]>,
      v5: React.SetStateAction<string>,
      v6: React.SetStateAction<string>,
      v7: React.SetStateAction<string>,
      value8: React.SetStateAction<string>
    ) =>
      () => {
        setv1(v1);
        setv2(v2);
        setv3(v3);
        setv4(v4);
        setv5(v5);
        setv6(v6);
        setv7(v7);
        setv8(value8);
        setNeededMenu('BrandDelete');
        setButtonClicked(true);
      };

  const ProductCreateClick = () => {
    setNeededMenu('ProductCreate');
    setButtonClicked(true);
  };

  const ProductEditClick =
    (
      p1: React.SetStateAction<string>,
      p2: React.SetStateAction<string>,
      p3: React.SetStateAction<string>,
      p4: React.SetStateAction<{ value: string; label: string }>
    ) =>
      () => {
        setp1(p1); //product
        setp2(p2); // description
        setp3(p3); //id
        setp4(p4); //brand
        setNeededMenu('ProductEdit');
        setButtonClicked(true);
      };

  const ProductDeleteClick =
    (
      p1: React.SetStateAction<string>,
      p2: React.SetStateAction<string>,
      p3: React.SetStateAction<string>,
      p4: React.SetStateAction<{ value: string; label: string }>
    ) =>
      () => {
        setp1(p1); //product
        setp2(p2); // description
        setp3(p3); //id
        setp4(p4); //brand
        setNeededMenu('ProductDelete');
        setButtonClicked(true);
      };

  const AudienceCreateClick = () => {
    setNeededMenu('AudienceCreate');
    setButtonClicked(true);
  };

  const AudienceEditClick =
    (
      a1: React.SetStateAction<string>,
      a2: React.SetStateAction<{ value: string; label: string }>,
      a3: React.SetStateAction<string[]>,
      a4: React.SetStateAction<string[]>,
      a5: React.SetStateAction<string[]>,
      a6: React.SetStateAction<string[]>,
      a7: React.SetStateAction<string>,
      a8: React.SetStateAction<string>,
      a9: React.SetStateAction<string>,
      a10: React.SetStateAction<string>,
      a11: React.SetStateAction<string>,
      a12: React.SetStateAction<string>
    ) =>
      () => {
        seta1(a1); //audience
        seta2(a2); // brand
        seta3(a3); //gender
        seta4(a4); //age
        seta5(a5); //occupation
        seta6(a6); //location
        seta7(a7); //painpoint
        seta8(a8); //id
        seta9(a9); //goals
        seta10(a10); //barriers
        seta11(a11); //triggers
        seta12(a12); //pp
        setNeededMenu('AudienceEdit');
        setButtonClicked(true);
      };

  const AudienceDeleteClick =
    (
      a1: React.SetStateAction<string>,
      a2: React.SetStateAction<{ value: string; label: string }>,
      a3: React.SetStateAction<string[]>,
      a4: React.SetStateAction<string[]>,
      a5: React.SetStateAction<string[]>,
      a6: React.SetStateAction<string[]>,
      a7: React.SetStateAction<string>,
      a8: React.SetStateAction<string>,
      a9: React.SetStateAction<string>,
      a10: React.SetStateAction<string>,
      a11: React.SetStateAction<string>,
      a12: React.SetStateAction<string>
    ) =>
      () => {
        seta1(a1); //audience
        seta2(a2); // brand
        seta3(a3); //gender
        seta4(a4); //age
        seta5(a5); //occupation
        seta6(a6); //location
        seta7(a7); //painpoint
        seta8(a8); //id
        seta9(a9); //goals
        seta10(a10); //barriers
        seta11(a11); //triggers
        seta12(a12); //pp
        setNeededMenu('AudienceDelete');
        setButtonClicked(true);
      };

  const sendData = () => {
    // Sends the data to the parent component
    onButtonClick(
      v1,
      id,
      v3,
      v4,
      v5,
      v6,
      v7,
      v8,
      v9,
      v10,
      v11,
      p1,
      p2,
      p3,
      p4,
      a1,
      a2,
      a3,
      a4,
      a5,
      a6,
      a7,
      a8,
      a9,
      a10,
      a11,
      a12,
      neededMenu
    );
  };

  const closeBrand = () => {
    // Handle the close event here
    setShowBrandPopup(false);
  };

  const closeEditBrand = () => {
    setEditPopup(false);
  };

  const closeProduct = () => {
    // Handle the close event here
    setShowProductPopup(false);
  };

  const closeEditProduct = () => {
    setProEditPopup(false);
  };
  const brandProductPersonas = productPersonas?.filter(
    (campaign) => campaign.brand.label === B1
  );

  const closeAudience = () => {
    // Handle the close event here
    setShowAudiencePopup(false);
  };

  const closeEditAudience = () => {
    setAudEditPopup(false);
  };

  const brandSelectedContent = audiencePersonas?.filter(
    (campaign) => campaign.brand.label === B1
  );

  const [shouldJiggle, setShouldJiggle] = useState<boolean>(false);

  const defaultPurposeOptions = [
    'Entertainment',
    'Educational',
    'Promotion',
    'Inspiration',
    'News',
    'Reviews',
    'Opinion',
    'How-to',
  ];

  // Inputs may need to be prefilled
  if (!youtubeVideoScriptInput) return null;

  return (
    <Formik
      initialValues={youtubeVideoScriptInput}
      onSubmit={async (values, actions) => {
        if (B1 === '') {
          setBrandError(true);
          const target = document.querySelector('#brand') as HTMLElement;
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        if (A1 === '') {
          setAudError(true);
          const target = document.querySelector('#aud') as HTMLElement;
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        await logRecentPersonaData({
          RecentBrand: B1,
          RecentProfilePic: picture,
          RecentDescription: B2,
          RecentWebsite: B3,
          RecentTone: B4,
          RecentIndustry: B5,
          RecentBrandAvoidArray: B7,
          RecentBrandReplacementArray: B8,
          RecentBrandSparinglyArray: B9,
          RecentAudience: A0,
          RecentAudienceProfilePic: picture2,
          RecentPainpoints: A1,
          RecentLocation: A2,
          RecentOccupation: A3,
          RecentAge: A4,
          RecentAudienceGoals: A5,
          RecentAudienceTriggers: A7,
          RecentAudienceBarriers: A6,
          RecentProduct: P1,
          RecentProductDescription: P2,
        });

        values.brand = B1;
        values.brandAvoidArray = B7;
        values.brandReplacementArray = B8;
        values.brandSparinglyArray = B9;
        values.brandDescription = B2;
        values.website = B3;
        values.tone = B4;
        values.industry = B5;
        values.audience = A0;
        values.painpoint = A1;
        values.location = A2;
        values.occupation = A3;
        values.age = A4;
        values.goals = A5;
        values.barriers = A6;
        values.triggers = A7;

        await submitContentForm({
          values,
          actions,
          formType: FormType.YOUTUBE_VIDEO_SCRIPT,
        });
      }}
      validationSchema={EGInputsSchema}
    >
      {(props) => (
        <>
          <div className={formStyles['form-container']}>
            <ListenToFormikValues
              callBackFunc={(values) => {
                setYoutubeVideoScriptInput(values as YoutubeVideoScriptInput);
                setCanKeepGoing(true);
              }}
            />

            <div>
              <div className={styles['create-button2']}>
                <div>
                  <h2 id="brand">Brand Persona</h2>
                </div>
              </div>

              {/* The Start of the DropDowns */}

              <div ref={menuRef}>
                {showBrandPopup && (
                  <BasicPopup2 id="persona-popup">
                    <div className={styles['popup-container']}>
                      <div className={styles['popup-header-container']}>
                        <h3>Brand Persona Creation</h3>
                        <button onClick={() => setShowBrandPopup(false)}>
                          <Image
                            src="/icons/CloseBlack.svg"
                            alt="Close"
                            layout="fixed"
                            objectFit="contain"
                            height={24}
                            width={24}
                          />
                        </button>
                      </div>
                      <div className={styles['inner']}>
                        {<BrandPersonaSoloPopup onClose={closeBrand} />}
                      </div>
                    </div>
                  </BasicPopup2>
                )}
                {showEditPopup && (
                  <BasicPopup2 id="persona-popup">
                    <div className={styles['popup-container']}>
                      <div className={styles['popup-header-container']}>
                        <h3>Brand Persona Creation</h3>
                        <button onClick={() => setEditPopup(false)}>
                          <Image
                            src="/icons/CloseBlack.svg"
                            alt="Close"
                            layout="fixed"
                            objectFit="contain"
                            height={24}
                            width={24}
                          />
                        </button>
                      </div>
                      <div className={styles['inner']}>
                        {
                          <EditBrandPersonaPopup
                            brand={v1}
                            tone={v4}
                            industry={v5}
                            profilePic={v3}
                            id={id}
                            website={v6}
                            description={v7}
                            brandPositioning={v8}
                            brandNoNoWords={v9}
                            brandReplacementWords={v10}
                            brandUseSparinglyWords={v11}
                            onClose={closeEditBrand}
                          />
                        }
                      </div>
                    </div>
                  </BasicPopup2>
                )}
                {showDeletePopup && (
                  <BasicPopup2 id="persona-popup">
                    <div className={styles['popup-container']}>
                      <div className={styles['popup-header-container']}>
                        <button onClick={() => setDeletePopup(false)}>
                          <Image
                            src="/icons/CloseBlack.svg"
                            alt="Close"
                            layout="fixed"
                            objectFit="contain"
                            height={24}
                            width={24}
                          />
                        </button>
                      </div>
                      <div className={styles['center']}>
                        <div>
                          <div
                            className={styles['DeleteText']}
                            style={{ textAlign: 'center' }}
                          >
                            <b>
                              Are you sure you want to remove this brand persona?
                              <br />
                              <span
                                style={{
                                  display: 'block',
                                  fontWeight: 'normal',
                                  marginTop: '3px',
                                }}
                              >
                                This action is <strong>permanent</strong>.
                              </span>
                              <span
                                style={{
                                  display: 'block',
                                  fontWeight: 'normal',
                                  marginTop: '3px',
                                }}
                              >
                                Your team will lose access to this persona.
                              </span>
                              <span
                                style={{
                                  display: 'block',
                                  fontWeight: 'normal',
                                  marginTop: '3px',
                                }}
                              >
                                All linked audience personas will be deleted.
                              </span>
                            </b>
                          </div>
                          <div className={styles['DeleteButtons']}>
                            <BasicButton
                              theme="dark"
                              type="button"
                              loading={loading}
                              disabled={false}
                              text="Cancel"
                              onClick={() => {
                                setDeletePopup(!showDeletePopup);
                              }}
                              extraStyles={{
                                scale: '100%',
                              }}
                            />{' '}
                            <span>&nbsp;</span> <span>&nbsp;</span>
                            <BasicButton
                              theme="red"
                              type="button"
                              loading={loading}
                              disabled={false}
                              text="Delete"
                              image={{
                                src: '/icons/DeleteWhite.svg',
                                height: 16,
                                width: 16,
                              }}
                              onClick={async () => {
                                await deleteBrand({ id });
                                setDeletePopup(!showDeletePopup);
                              }}
                              extraStyles={{
                                scale: '100%',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </BasicPopup2>
                )}
                <DropDownContainer>
                  <DropDownHeader
                    onClick={toggling}
                    className={shouldJiggle ? styles['jiggle'] : ''}
                  >
                    <div>
                      <Image
                        src={picture ? picture : '/icons/nobrand.svg'}
                        alt="Close"
                        layout="fixed"
                        objectFit="contain"
                        height={24}
                        width={24}
                        className={styles['image2']}
                      />
                    </div>{' '}
                    <span>&nbsp;</span>
                    <Innertext>
                      {selectedOption ? selectedOption : 'Choose a Brand'}
                    </Innertext>
                    <DropDownIcon>
                      <Image
                        src={'/icons/Arrow Chevron Down.svg'}
                        alt="Close"
                        layout="fixed"
                        objectFit="contain"
                        height={24}
                        width={24}
                        className={styles['image']}
                      />
                    </DropDownIcon>
                  </DropDownHeader>
                  {isOpen && (
                    <DropDownListContainer>
                      <DropDownList>
                        {userData?.position !== 'Content Creator' && (
                          <ListItem2
                            key={'create'}
                            onClick={() => BrandCreateClick()}
                          >
                            <Image
                              src={'/icons/Actions Plus.svg'}
                              alt=""
                              objectFit="contain"
                              layout="fixed"
                              width={24}
                              height={24}
                            />{' '}
                            <span>&nbsp;</span>
                            <div className={styles['left-space']}>
                              Create a Brand Persona
                            </div>
                          </ListItem2>
                        )}
                        {brandPersonas?.map((company) => (
                          <ListItem key={company.id} value={selectedBrand}>
                            <div
                              className={styles['pic-image']}
                              onClick={onOptionClicked(
                                company.brand,
                                company.description,
                                company.website,
                                company.tone,
                                company.industry,
                                company.profilePic,
                                company.brandPositioning ?? '',
                                company.brandNoNoWords ?? [''],
                                company.brandReplacementWords ?? [
                                  { replaceThis: '', withThis: '' },
                                ],
                                company.brandUseSparinglyWords ?? [''],
                                    company,
                              )}
                            >
                              <Image
                                src={
                                  company.profilePic
                                    ? company.profilePic
                                    : '/icons/nobrand.svg'
                                }
                                alt="Close"
                                layout="fixed"
                                objectFit="contain"
                                height={24}
                                width={24}
                                className={styles['image2']}
                              />{' '}
                              <span>&nbsp;</span>
                              <div className={styles['left-space']}>
                                {company.brand}
                              </div>
                            </div>
                            {((userData?.organizationOwner &&
                              company.organizationPersona) ||
                              !company.organizationPersona) &&
                              userData?.position !== 'Content Creator' && (
                                <div className={styles['BrandEdit']}>
                                  <div
                                    className={styles['edit-button']}
                                    onClick={BrandEditClick(
                                      company.brand,
                                      company.id,
                                      company.profilePic,
                                      company.tone,
                                      company.industry,
                                      company.website,
                                      company.description,
                                      company.brandPositioning ?? '',
                                      company.brandNoNoWords ?? [''],
                                      company.brandReplacementWords ?? [
                                        { replaceThis: '', withThis: '' },
                                      ],
                                      company.brandUseSparinglyWords ?? [''],
                                    )}
                                  >
                                    <Image
                                      src={'/icons/Edit_Icon.svg'}
                                      alt="Close"
                                      layout="fixed"
                                      objectFit="contain"
                                      height={14}
                                      width={14}
                                      className={styles['image']}
                                    />
                                  </div>{' '}
                                  <span>&nbsp;</span>
                                  <div
                                    className={styles['delete-button']}
                                    onClick={BrandDeleteClick(
                                      company.brand,
                                      company.id,
                                      company.profilePic,
                                      company.tone,
                                      company.industry,
                                      company.website,
                                      company.description,
                                      company.brandPositioning ?? ''
                                    )}
                                  >
                                    <Image
                                      src={'/icons/Delete.svg'}
                                      alt="Close"
                                      layout="fixed"
                                      objectFit="contain"
                                      height={14}
                                      width={14}
                                      className={styles['image']}
                                    />
                                  </div>
                                </div>
                              )}
                          </ListItem>
                        ))}
                      </DropDownList>
                    </DropDownListContainer>
                  )}
                </DropDownContainer>
                {brandError && (
                  <p>
                    <span style={{ color: '#FF0000' }}>
                      Please Select a Brand
                    </span>
                  </p>
                )}
              </div>
            </div>

            <div>
              <div className={styles['create-button']}>
                <div>
                  <h2 id="aud">Audience Persona</h2>
                </div>
                <div></div>
              </div>
              <div ref={menuRef2}>
                {showAudiencePopup && (
                  <BasicPopup2 id="persona-popup">
                    <div className={styles['popup-container5']}>
                      <div className={styles['popup-header-container']}>
                        <h3>Audience Persona Creation</h3>
                        <button onClick={() => setShowAudiencePopup(false)}>
                          <Image
                            src="/icons/CloseBlack.svg"
                            alt="Close"
                            layout="fixed"
                            objectFit="contain"
                            height={24}
                            width={24}
                          />
                        </button>
                      </div>
                      <div className={styles['inner']}>
                        {<AudiencePersonaSoloPopup onClose={closeAudience} />}
                      </div>
                    </div>
                  </BasicPopup2>
                )}
                {showAudEditPopup && (
                  <BasicPopup2 id="persona-popup">
                    <div className={styles['popup-container5']}>
                      <div className={styles['popup-header-container']}>
                        <h3>Audience Persona Creation</h3>
                        <button onClick={() => setAudEditPopup(false)}>
                          <Image
                            src="/icons/CloseBlack.svg"
                            alt="Close"
                            layout="fixed"
                            objectFit="contain"
                            height={24}
                            width={24}
                          />
                        </button>
                      </div>
                      <div className={styles['inner']}>
                        {
                          <EditAudiencePersonaPopup
                            brand={a2}
                            id={a8}
                            audience={a1}
                            age={a4}
                            occupation={a5}
                            location={a6}
                            painpoints={a7}
                            gender={a3}
                            goals={a9}
                            barriers={a10}
                            triggers={a11}
                            profilePic={a12}
                            onClose={closeEditAudience}
                          />
                        }
                      </div>
                    </div>
                  </BasicPopup2>
                )}
                {showAudDeletePopup && (
                  <BasicPopup2 id="persona-popup">
                    <div className={styles['popup-container']}>
                      <div className={styles['popup-header-container']}>
                        <button onClick={() => setAudDeletePopup(false)}>
                          <Image
                            src="/icons/CloseBlack.svg"
                            alt="Close"
                            layout="fixed"
                            objectFit="contain"
                            height={24}
                            width={24}
                          />
                        </button>
                      </div>
                      <div className={styles['center']}>
                        <div>
                          <div className={styles['DeleteText']}>
                            <b>Are you sure you want to delete this persona?</b>
                          </div>
                          <div className={styles['DeleteButtons']}>
                            <BasicButton
                              theme="dark"
                              type="button"
                              loading={loading}
                              disabled={false}
                              text="Cancel"
                              onClick={() => {
                                setAudDeletePopup(!showAudDeletePopup);
                              }}
                              extraStyles={{
                                scale: '100%',
                              }}
                            />{' '}
                            <span>&nbsp;</span> <span>&nbsp;</span>
                            <BasicButton
                              theme="red"
                              type="button"
                              loading={loading}
                              disabled={false}
                              text="Delete"
                              image={{
                                src: '/icons/DeleteWhite.svg',
                                height: 16,
                                width: 16,
                              }}
                              onClick={async () => {
                                const id = a8;
                                await deleteAudience({ id });
                                setAudDeletePopup(!showAudDeletePopup);
                              }}
                              extraStyles={{
                                scale: '100%',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </BasicPopup2>
                )}
                <DropDownContainer3>
                  <DropDownHeader
                    onClick={toggling2}
                    className={B1 !== '' ? '' : styles['gray']}
                  >
                    <div>
                      <Image
                        src={picture2 ? picture2 : '/icons/nobrand.svg'}
                        alt="Close"
                        layout="fixed"
                        objectFit="contain"
                        height={24}
                        width={24}
                        className={styles['image2']}
                      />
                    </div>{' '}
                    <span>&nbsp;</span>
                    <Innertext>
                      {selectedAudOption
                        ? selectedAudOption
                        : 'Choose an Audience'}
                    </Innertext>
                    <DropDownIcon3>
                      <Image
                        src={'/icons/Arrow Chevron Down.svg'}
                        alt="Close"
                        layout="fixed"
                        objectFit="contain"
                        height={24}
                        width={24}
                        className={B1 !== '' ? '' : styles['opac']}
                      />
                    </DropDownIcon3>
                  </DropDownHeader>
                  {isOpen2 && (
                    <DropDownListContainer>
                      <DropDownList>
                        {userData?.position !== 'Content Creator' && (
                          <ListItem2
                            key={'create'}
                            onClick={() => AudienceCreateClick()}
                          >
                            <Image
                              src={'/icons/Actions Plus.svg'}
                              alt=""
                              objectFit="contain"
                              layout="fixed"
                              width={24}
                              height={24}
                            />{' '}
                            <span>&nbsp;</span>
                            <div className={styles['left-space']}>
                              Create an Audience Persona
                            </div>
                          </ListItem2>
                        )}
                        {brandSelectedContent?.map((company) => (
                          <ListItem key={company.id} value={selectedAudience}>
                            <div
                              className={styles['pic-image']}
                              onClick={onAudOptionClicked(
                                company.audience,
                                company.painpoints,
                                company.location,
                                company.occupation,
                                company.age,
                                company.goals ?? '',
                                company.barriers ?? '',
                                company.triggers ?? '',
                                company.profilePic ?? '',
                                company,
                              )}
                            >
                              <Image
                                src={
                                  company.profilePic
                                    ? company.profilePic
                                    : '/icons/nobrand.svg'
                                }
                                alt="Close"
                                layout="fixed"
                                objectFit="contain"
                                height={24}
                                width={24}
                                className={styles['image2']}
                              />{' '}
                              <span>&nbsp;</span>
                              <div className={styles['left-space']}>
                                {company.audience}
                              </div>
                            </div>
                            {((userData?.organizationOwner &&
                              company.organizationPersona) ||
                              !company.organizationPersona) &&
                              userData?.position !== 'Content Creator' && (
                                <div className={styles['BrandEdit']}>
                                  <div
                                    className={styles['edit-button']}
                                    onClick={AudienceEditClick(
                                      company.audience,
                                      company.brand,
                                      company.gender,
                                      company.age,
                                      company.occupation,
                                      company.location,
                                      company.painpoints,
                                      company.id,
                                      company.goals ?? '',
                                      company.barriers ?? '',
                                      company.triggers ?? '',
                                      company.profilePic ?? ''
                                    )}
                                  >
                                    <Image
                                      src={'/icons/Edit_Icon.svg'}
                                      alt="Close"
                                      layout="fixed"
                                      objectFit="contain"
                                      height={14}
                                      width={14}
                                      className={styles['image']}
                                    />
                                  </div>{' '}
                                  <span>&nbsp;</span>
                                  <div
                                    className={styles['delete-button']}
                                    onClick={AudienceDeleteClick(
                                      company.audience,
                                      company.brand,
                                      company.gender,
                                      company.age,
                                      company.occupation,
                                      company.location,
                                      company.painpoints,
                                      company.id,
                                      company.goals ?? '',
                                      company.barriers ?? '',
                                      company.triggers ?? '',
                                      company.profilePic ?? ''
                                    )}
                                  >
                                    <Image
                                      src={'/icons/Delete.svg'}
                                      alt="Close"
                                      layout="fixed"
                                      objectFit="contain"
                                      height={14}
                                      width={14}
                                      className={styles['image']}
                                    />
                                  </div>
                                </div>
                              )}
                          </ListItem>
                        ))}
                      </DropDownList>
                    </DropDownListContainer>
                  )}
                </DropDownContainer3>
                {audError && (
                  <p>
                    <span style={{ color: '#FF0000' }}>
                      Please Select an Audience
                    </span>
                  </p>
                )}
              </div>
            </div>

            <div>
              <div className={styles['create-button']}>
                <div>
                  <h2>Topic</h2>
                </div>
                <div>
                  <BasicInput
                    id="topic"
                    label={<></>}
                    placeholder="Marketing Tips of the week"
                    value={props.values.videoTopic}
                    setValue={props.handleChange('videoTopic')}
                    disabled={false}
                    errors={props.errors.videoTopic as string}
                    touched={props.touched.videoTopic ? true : false}
                    onBlur={props.handleBlur}
                  />
                </div>
              </div>
            </div>

            <div>
              <div>
                <h2>What is this video's main purpose? (Optional) </h2>
              </div>
              <BasicButtonSelectionInput
                allowUserInput
                id="videoPurpose"
                label={<div></div>}
                defaultOptions={defaultPurposeOptions}
                value={props.values.videoPurpose}
                setValue={props.handleChange('videoPurpose')}
                disabled={loading}
                errors={props.errors.videoPurpose as string}
                touched={props.touched.videoPurpose ? true : false}
                onBlur={props.handleBlur}
              />
            </div>

            <AdvancedInputs formikProps={props} disabled={loading} />
          </div>
          <GenerateResponseButtons
            onSubmit={() => {
              props.handleSubmit();
            }}
          />
        </>
      )}
    </Formik>
  );
};
